"use client";

import { Sparkles, RefreshCw } from "lucide-react";
import { useT } from "@/hooks/useT";

interface RecommendedForYouHeaderProps {
  /** Whether the refresh request is currently in flight (spins the icon, disables button). */
  refreshing: boolean;
  onRefresh: () => void;
  /** When true, adds `mt-6` for the list-view variant that sits below the Frens grid. */
  topMargin?: boolean;
}

/**
 * Header strip for the For-You category: "Recommended" title + refresh
 * icon button. The same JSX appeared twice in MarketsPageContent (grid
 * vs list variant) with the only difference being a top margin. Single
 * component, optional `topMargin` flag.
 */
export function RecommendedForYouHeader({ refreshing, onRefresh, topMargin = false }: RecommendedForYouHeaderProps) {
  const t = useT();
  return (
    <div className={`flex items-center justify-between mb-4${topMargin ? " mt-6" : ""}`}>
      <h3 className="text-lg font-monument font-bold text-gray-900 dark:text-white flex items-center gap-2">
        <Sparkles className="w-5 h-5 text-accent-primary" />
        {t("forYou.recommended")}
      </h3>
      <button
        onClick={onRefresh}
        disabled={refreshing}
        className="p-1.5 rounded-[5px] text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 hover:bg-black/5 dark:hover:bg-white/5 transition-colors disabled:opacity-50"
        aria-label="Refresh recommendations"
      >
        <RefreshCw className={`w-4 h-4 ${refreshing ? "animate-spin" : ""}`} />
      </button>
    </div>
  );
}
